var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15662",
    "data-name": "Path 15662",
    d: "M22,11H4.414L9.707,5.707A1,1,0,1,0,8.293,4.293l-7,7a1,1,0,0,0,0,1.414l7,7a1,1,0,1,0,1.414-1.414L4.414,13H22a1,1,0,0,0,0-2Z",
    transform: "translate(-1 -4)",
    fill: "#4c36e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.07ef2dcccc5057598d59b4210ad7f9d2.svg";
export { ForwardRef as ReactComponent };